/**
 * Styl čáry.
 */
export enum LineStyle {
    /**
     * Plná čára.
     */
    SOLID = 'solid',

    /**
     * Čárkovaná čára.
     */
    DASHED = 'dashed',
}
